import React, { useEffect, useRef } from "react";
import { GoArrowRight, GoArrowUpRight } from "react-icons/go";
import Marquee from "react-fast-marquee";
import { NavLink } from "react-router-dom";
import { useGetAllProjectsQuery } from "../../Redux/getApi";

const Projects = () => {
  const scrollRef = useRef(null);
  const scrollStep = 160;
  const intervalTime = 3000;

  useEffect(() => {
    const scrollContainer = scrollRef.current;

    if (!scrollContainer) return;

    const originalScrollWidth = scrollContainer.scrollWidth / 2;

    const scrollLoop = setInterval(() => {
      if (scrollContainer.scrollLeft >= originalScrollWidth) {
        scrollContainer.scrollLeft = 0;
      }

      scrollContainer.scrollBy({
        left: scrollStep,
        behavior: "smooth",
      });
    }, intervalTime);

    return () => clearInterval(scrollLoop);
  }, []);

  const { data } = useGetAllProjectsQuery();
  const projects = data?.projects || [];

  const items = projects?.slice(0, 3).map((project) => ({
    id: project?._id,
    src: project?.coverImage?.imageUrl,
    label: project?.title,
  }));
  return (
    <>
      {data?.projects?.length > 0 && (
        <div className=" w-full flex-col items-center gap-8 pt-8">
          <div className="flex flex-col items-center gap-4">
            <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] text-center font-bold">
              Recent Projects
            </span>
            <span className="text-[#7A7A7A] md:text-[1.2rem] text-[1rem] text-center">
              Explore the Rawalpindi Development Authority's latest development
              projects
            </span>
            <NavLink
              to={"/project-2"}
              className="flex justify-center items-center gap-2 border border-[#00643b] text-[#00643b]  py-2 px-4 xl:text-[1.2rem] lg:text-[1rem] text-[.9rem] font-semibold rounded-lg"
            >
              View All Projects <GoArrowRight className="xl:size-5 size-4" />
            </NavLink>
          </div>
          <div className=" hidden md:grid grid-cols-3 w-full mt-8 ">
            {items.map(({ id, src, label }, i) => (
              <NavLink
                to={`/project/${id}`}
                key={i}
                className="w-full relative group overflow-hidden"
              >
                <img
                  src={src}
                  className=" group-hover:scale-150 object-contain w-full transition-all duration-300 "
                  alt=""
                />
                <span className=" absolute sm:bottom-4 bottom-3 sm:left-4 left-2 xl:text-[2rem] lg:text-[1.6rem] sm:text-[1.2rem] text-[.9rem] font-bold text-white">
                  {label}
                </span>
                <GoArrowUpRight className="xl:size-10 sm:size-8 size-6 absolute sm:top-6 top-3 sm:right-6 right-3 transition-opacity duration-500  p-2 border rounded-full border-white group-hover:border-[#00643b] bg-none group-hover:bg-[#00643b] cursor-pointer font-bold text-white " />
              </NavLink>
            ))}
          </div>
          <div className="w-full overflow-x-auto custom-scroll md:hidden mt-5 transition-all duration-700 ease-in-out">
            <div className="flex  gap-4 px-4 pb-4 w-max">
              {[...items].map(({ src, label }, i) => (
                <div
                  key={i}
                  className="w-[15rem] flex-shrink-0 relative rounded-xl overflow-hidden"
                >
                  <img
                    src={src}
                    alt={label}
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute bottom-3 left-2 text-[0.9rem] sm:text-[1.2rem] font-bold text-white drop-shadow">
                    {label}
                  </span>
                  <GoArrowUpRight className="size-6 sm:size-8 absolute top-3 right-3 p-1 border rounded-full cursor-pointer font-bold text-white" />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <NavLink to={"/ihs"} className="cursor-pointer">
        <Marquee
          direction="left"
          gradient={false}
          pauseOnHover={true}
          speed={50}
          className="bg-[#DEE9E4] md:py-3 py-2"
        >
          <div className="flex items-center gap-12 font-bold lg:text-[1.5rem] md:text-[1.3rem] text-[1rem] px-6">
            <span>
              Beware of <span className="text-[#D80000]">Frauds/Scams</span> of
              Private Housing Societies
            </span>
            <span>
              View All <span className="text-[#D80000]">Illegal</span> Housing
              Societies
            </span>
            <span>
              Beware of <span className="text-[#D80000]">Frauds/Scams</span> of
              Private Housing Societies
            </span>
          </div>
        </Marquee>
      </NavLink>
    </>
  );
};

export default Projects;
